// @flow

import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'shared/routing/withRouter';
import Spinner from '../../../components/contentLoader/spinner';
import { bindActionCreators } from 'redux';
import {getDetailOfSurvey,selectSurveyOption,submitSurvey,selectLeadOption,storeSurveyData,handleChangeLeadQuestion} from '../action';
import queryString from 'query-string';
import Coupon from '../../../assets/Coupon.png';
import ErrorDialogBox from '../../../components/Common/dialogContainer'
import goldIcon from '../../../assets/web_e_com_ic_brand_gold.png'
import platIcon from '../../../assets/web_e_com_ic_brand_platinum.png'
import skipIcon from '../../../assets/ic_arrow_month_right_link_user.png'
import { Avatar } from "@react-md/avatar";
import { Divider } from "@react-md/divider";

// #endregion"
var playTimeVedio = 0
class Survey extends React.Component {
  constructor(props){
    super(props);
    const { location } = this.props;
    const parsed = queryString.parse(location.search);
    this.state={ 
      url:parsed.url,
      adId:parsed.aid,
      uid:parsed.uid,
      isChecked:false,
      adData : {},
      surveyList : [],
      errMsg:"",
      isLeadOptionEnable : false , 
      progressSlider:0,
      isErrorDialogVisible:false,
      isVideoPlay:false,
      playing:false,
      phoneNumber:"",
      email:'',
      isLoading:false,
      showSkipButton:false,
    }
  }

  componentDidMount(){
    this.setState({isLoading:true})
    this.props.getDetailOfSurvey(this.state.url)
    .then((res)=>{
      if(res.action.payload.data.CategoryCode == "SURVTEMP2"){
        this.setState({
          isVideoPlay : true, 
          progressSlider:0,
        })
      }
      playTimeVedio = res.action.payload.data.vedioPlayTime
      this.setState({isLoading:false})
    })
    .catch(() => {
      this.setState({isLoading:false})
    })
  }

  onOptionCheck(item){
    this.props.selectSurveyOption(item)
  }
  onOptionLeadCheck(id, i, index){
    var item = {
      "optionKey" : id,
      "i" : i,
      "index" :index,
    }
    this.props.selectLeadOption(item)
  }
  onSubmitSurvey(){
    const { location, history } = this.props;
    const search = location.search;
    var surveyList = this.props.surveyList.filter(item => item.IsSelected );
    if(surveyList.length>0){
      if(this.props.detailOfSurvey.IsLeadOptionEnable){
        this.setState({
          isLeadOptionEnable:true
        })
      }else{
        if(search.includes('share=true')){
          var setModel={
            "AdKey":this.props.detailOfSurvey.AdKey,
            "ValidatorKey":this.props.detailOfSurvey.EncryptedCode,
            "selectedQuantity" : this.props.selectedQuantity,
            "OptionModelArrayList":this.props.surveyList,
          }
          this.props.storeSurveyData(setModel);
          this.setState({ isLoding: false });
          history.push({
            pathname: '/verify',
            search,
          })

          // window.location.href = "/verify" + search
        }
      }
    }else{
      this.setState({
        errMsg:"Please select option",
        isErrorDialogVisible:true
      })
    }
  }
  onSubmitLeadQuestion(){
    var leadOption = [];
    var reward = 0 ;
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(this.state.phoneNumber !== ""){
      if(this.state.phoneNumber.length !== 10){
        this.setState({
          errMsg:"Please Enter Valid Contact Number",
          isErrorDialogVisible:true
        })
      } 
    }
    if(this.state.email !== ""){
      if(!re.test(this.state.email)){
        this.setState({
          errMsg:"Please Enter Valid Email Id",
          isErrorDialogVisible:true
        })
      } 
    }
    var leadList = this.props.leadQuestionList;
    for(var leadItr=0;leadItr<leadList.length;leadItr++){
      var leadOption = leadList[leadItr].leadOptionArrayList;
      for(var leadOptItr=0;leadOptItr<leadOption.length;leadOptItr++){
        if(leadOption[leadOptItr].IsSelected){
         if(leadOption[leadOptItr].ISEditable){
          if(leadOption[leadOptItr].Format == 0){
            if(this.state.phoneNumber.length != 10){
              this.setState({
                errMsg:"Please Enter Valid Contact Number",
                isErrorDialogVisible:true
              })
              return;
            }else{
              leadOption[leadOptItr].LeadOptionValue = this.state.phoneNumber
              reward = reward+leadOption[leadOptItr].OptionReward
            }
          }
          if(leadOption[leadOptItr].Format == 1){
            if(!re.test(this.state.email)){
              this.setState({
                errMsg:"Please Enter Valid Email Id",
                isErrorDialogVisible:true
              })
              return;
            }else{
              leadOption[leadOptItr].LeadOptionValue = this.state.email
              reward = reward+leadOption[leadOptItr].OptionReward
            }
          }
         }else{
            reward = reward+leadOption[leadOptItr].OptionReward
         }
        }
      }
    }
    var leadOption = []
    const { location, history } = this.props;
    const search = location.search;
    this.props.leadQuestionList.filter(item => {
      leadOption = item.leadOptionArrayList.filter(que => que.IsSelected)
    })
    if(leadOption.length>0){
      if(search.includes('share=true')){
        var setModel={
          "AdKey":this.props.detailOfSurvey.AdKey,
          "UserKey":"",
          "ValidatorKey":this.props.detailOfSurvey.EncryptedCode,
          "OptionModelArrayList":this.props.surveyList,
          "listOfLeadOptionDetailArrayList": this.props.leadQuestionList,
  
        }
        this.props.submitSurvey(setModel) 
        .then((resp)=>{
          if (resp.value.data.Status == 1 || resp.value.data.Status == 0){
            history.replace({
              pathname: '/verify',
              search,
            })
            // window.location.href = "/verify" + search
          }
        })
        .catch(function (err) {
          console.log(err)
      }.bind(this));
       
      }else{
        var setModel={
          "AdKey":this.props.detailOfSurvey.AdKey,
          "UserKey":this.state.uid,
          "ValidatorKey":this.props.detailOfSurvey.EncryptedCode,
          "OptionModelArrayList":this.props.surveyList,
          "listOfLeadOptionDetailArrayList": this.props.leadQuestionList,
        }
        this.props.submitSurvey(setModel) 
        .then((resp)=>{
          if (resp.value.data === 1){
            if( this.state.url.includes("share=true") ){
              this.props.history.replace({pathname:"/thankYou"})
            }else{
              this.closeEmbeddedView()
            }
          }
        })
        .catch(function (err) {
          console.log(err)
      }.bind(this));
      }
    }else{
      this.setState({
        errMsg:"Please select option",
        isErrorDialogVisible:true,
      })
    }
  }
  closeDialog(){
    this.setState({
      errMsg:"",
      isErrorDialogVisible:false,
    })
  }
  closeEmbeddedView(){
    const w = window;
    if ((w).ReactNativeWebView && typeof (w).ReactNativeWebView.postMessage === 'function') {
      try {
        (w).ReactNativeWebView.postMessage(
          JSON.stringify({ type: 'CLOSE_WEBVIEW', source: 'survey_submit' })
        );
      } catch (_error) {
        (w).ReactNativeWebView.postMessage('CLOSE_WEBVIEW');
      }
      return;
    }
    if (w.history.length > 1) {
      w.history.back();
      return;
    }
    w.close();
  }
  onEndVideo(){
    this.setState({
      isVideoPlay:false,
      progressSlider:0
    })
  }
  onProgress(data) {
    var video = document.getElementById('video');
    var supposedCurrentTime = 0;
    video.addEventListener('timeupdate', function() {
      if (!video.seeking) {
        supposedCurrentTime = video.currentTime;
      }
   
    });
    video.addEventListener('paused', function() {
      if (video.paused) {
        video.paused =true
      }
   
    });
    video.addEventListener('seeking', function() {
    
      var delta = video.currentTime - supposedCurrentTime;
      if (Math.abs(delta) > 0.01) {
        video.currentTime = supposedCurrentTime;
      }
    });
    video.addEventListener('ended', function() {
      supposedCurrentTime = 0;
    });
 
   
  };
  onPlayVedio(e){
    console.log('play')
  }
  onLoading(data){
    console.log(data)
  }
  onSkip(){
    this.setState({
      isVideoPlay:false,
      progressSlider:0,
    })
  }
  onBuffer(isBufering){
    console.log("")
  }
  onError(value){
    console.log(value)
  }
  handleChangeLeadOption(item,event){
    if(item.Format == 0){
      this.setState({
        phoneNumber:event.target.value
      })
    }else if(item.Format == 1){
      this.setState({
        email:event.target.value
      })
    }
    this.props.handleChangeLeadQuestion(event.target.value,item.LeadOptionKey)    
  }
  ontimeupdate = element => {
    // var video = document.createElement('video');
    var currenttime = element.target.currentTime;
    console.log(currenttime)
    if(currenttime >= this.props.detailOfSurvey.VideoPlayTime){
      this.setState({
        showSkipButton:true,
      })
    }
   
  };
  render() {
    var Icon=''
    if(this.props.detailOfSurvey.SegmentCode === "PLAT"){
     Icon = platIcon  
    }else if(this.props.detailOfSurvey.SegmentCode === "GOLD"){
     Icon = goldIcon
    }
    const {detailOfSurvey,surveyList,leadQuestionList,isLoading} = this.props;

    var surveyOptionList = null ;
    var leadOptionList = null ; 
    if(detailOfSurvey.IsSurveyTypeText){
      surveyOptionList =  
      <div className="flex-container-reward">
        {surveyList !== undefined && surveyList.map((item,index) => {
            return(
              <div className='box' style={{height:"auto"}} key={index}>
                  <div className="ansCheckboxTxt No-br"  onClick={this.onOptionCheck.bind(this,item,index)}>
                    <div className="row">
                      <div className="col-md-1 col-sm-1 checkBoxPD">

                      {detailOfSurvey.IsSingleSelectionSurvey ? 
                          <div className="">
                                <input type="radio" className="inputRadioBtn" id={item.OptionKey} checked={item.IsSelected} />
                                <label for={item.OptionKey} onClick={this.onOptionCheck.bind(this,item,index)}></label>
                          </div>
                          : 
                          <div className="round txtCheckbox">
                              <input type="checkbox" id={item.OptionKey} checked={item.IsSelected} />
                              <label for={item.OptionKey} onClick={this.onOptionCheck.bind(this,item,index)}></label>
                           </div>
                      }
                      </div>
                      <div className="col-md-10 col-sm-10 no-Pd info-txt">
                          <div className="card-text F3">{item.OptionHeader} </div>
                          <div className="card-text F4 secondoryTextColor">{item.OptionSubHeader}</div>
                      </div>
                    </div>
                  </div>
              </div>  
            );
          })
        }
      </div> 
    }else{ 

      surveyOptionList = 
      <div className="flex-container-reward">
        {surveyList !== undefined && surveyList.map((item,index) => {
            return(
              <div className='box'>
                <div className="ansCheckbox" onClick={this.onOptionCheck.bind(this,item,index)}>
                   
                  {detailOfSurvey.IsSingleSelectionSurvey ? 

                    <div className="img_rdio">
                      <input type="radio" className="inputRadioBtn" id={item.OptionKey} checked={item.IsSelected} />
                      <label for={item.OptionKey} onClick={this.onOptionCheck.bind(this,item,index)}></label>
                    </div>
                    : 
                    <div className="round">
                      <input type="checkbox" id={item.OptionKey} checked={item.IsSelected} />
                      <label for={item.OptionKey} onClick={this.onOptionCheck.bind(this,item,index)}></label>
                    </div>
                    
                  }
                      <Avatar src={ item.OptionHeader } className="optionImgAvatar" />
                </div>
                <div className="card-text alignCen img-label">{item.OptionSubHeader}</div>
              </div>
            );
          })
        } 
        </div>
    }
   if(this.state.isLeadOptionEnable){
   leadOptionList = leadQuestionList !== undefined && leadQuestionList.map((data,index) => {
      return(
              <div className="card Mb-T10 card-height-auto-lead" key={index}> 
              <div className="card-body card-pd-sm">
  
                <div className="card-text F2 queText primaryTextColor alignCen">{data.LeadQuestion}</div>
               
                <div className="col-md-12 no-Pd">
             
                  {data.leadOptionArrayList !== undefined && data.leadOptionArrayList.map((item,i) => {
                      return(
                        <div className='box' style={{padding:"15px 0px"}} key={i}>
                            <div className="ansCheckboxTxt" style={{padding:"5px"}}>
                              <div className="row">
                                <div className="col-md-1 col-sm-1 checkBoxPD">
                                    <div className="round txtCheckbox">
                                          <input type="checkbox" id={item.LeadOptionKey} checked={item.IsSelected} />
                                          <label  for={item.LeadOptionKey} onClick={this.onOptionLeadCheck.bind(this,item.LeadOptionKey,i,index)}></label>
                                    </div>
                                </div>
                                <div className="col-md-11 col-sm-11 no-Pd info-txt">
                                  <div className="row" style={{position:"relative", top:"7px",fontSize:12}}>
                                  {item.ISEditable ?
                                   
                                   <div className="col-md-10 col-sm-10 no-Pd card-text" style={{width:'80%'}}>
                                     {item.Format == 0 ?
                                    <input 
                                      style={{fontSize:12, top:'0'}}
                                      value = {item.LeadOptionValue}
                                      onInput={ (e) => { e.target.value =  e.target.value.replace(/[^0-9]/g, '').slice(0, 10) } }
                                      onChange={this.handleChangeLeadOption.bind(this,item)}
                                      className={ 'borderEffect1'}
                                      name={item.Format == 0 ? 'Phone Number' : 'Email '}
                                      type={item.Format == 0 ? 'number' : 'email'}
                                      inputMode={item.Format == 0 ? 'numeric' : ''}
                                      max={item.Format == 0 ? '10' : '30' }
                                      autoFocus
                                      maxLength={item.Format == 0 ? 10 : 30 }
                                      placeholder={item.Format == 0 ? "+91(India) Mobile Number" : "email" }
                                    />:
                                    <input 
                                    style={{fontSize:12, top:'0'}}
                                    value = {item.LeadOptionValue}
                                    onChange={this.handleChangeLeadOption.bind(this,item)}
                                    className={ 'borderEffect1'}
                                    name={'Email'}
                                    type={'email'}
                                    max={ '30' }
                                    autoFocus
                                    maxLength={ 30 }
                                    placeholder={ "email" }
                                  />}
                                  </div>
                                  :
                                  <div className="col-md-10 col-sm-10 no-Pd card-text F2 ">{item.LeadOptionValue}</div> }
                                  {/* <div className="col-md-2 col-sm-2 card-text F3 alignEnd" style={{paddingRight:"5px", fontWeight:"600", width:'20%'}}>+{item.OptionReward}</div> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                        </div>  
                      );
                    })
                  }
                 </div>
              </div>
            </div>
      );
    });
   }
   var onSubmit = this.state.isLeadOptionEnable ? this.onSubmitLeadQuestion.bind(this) : this.onSubmitSurvey.bind(this)
    return (
      isLoading  || this.state.isLoading ?  <Spinner /> : 
      // !this.state.isVideoPlay ?
      <div className="bg-white-Res">
        <div className="row mobDiv">
          <div className="col-sm-12 col-md-12 col-lg-12 no-Pd">
            <div className="card"> 
              <div className="card-body no-Pd">
                <img src={this.props.detailOfSurvey.AdImagePath == null ? Coupon : this.props.detailOfSurvey.AdImagePath }   className="couponImg"/>
              </div>

              <div className="card-body card-pd-sm flex-row">    
                  
                  <div className="card-text F5 Fw">
                      <h5 className="card-title">{this.props.detailOfSurvey.AdName}</h5>
                      {Icon.length < 0 ? <img src={Icon} className="segmentIcon" /> : null}
                      {this.props.detailOfSurvey.SegmentName}
                  </div>

                  <div className="F3 Fw primaryColor RewardPoints-bg">
                       <span>reduce</span>
                       <span>maintenace</span>
                       ₹{parseInt(detailOfSurvey.Reward)}
                  </div>  
              </div>

            </div>
          </div>
        </div>

        <div className="deviderDiv" />

        <div className="row mobDiv Mb-T10">
          <div className="col-sm-12 col-md-12 col-lg-12 no-Pd">
          {!this.state.isLeadOptionEnable ?
             <div className="card card-height-auto"> 
              {!this.state.isVideoPlay ?
                <div className="card-text F2 queText primaryTextColor card-pd-sm">
                  <div> {detailOfSurvey.SurveyQuestion} </div> 
                   
                </div>:null}

                <Divider />

                <div className="card-body card-pd-sm">
                {!this.state.isVideoPlay ?
                    <div>
                      {surveyOptionList}
                    </div>:
                    <div>
                    <video 
                    // muted
                    autoPlay
                    id="video" 
                    disablePictureInPicture
                    controls 
                    onTimeUpdate={this.ontimeupdate.bind(this)}
                    controlsList="nodownload"
                    width="100%"
                    height="300px"
                    style={{zIndex:5}}
                    className='video-player'
                    onError={this.onError.bind(this)}
                    ref={this.handleVideoMounted}
                    src={detailOfSurvey.SurveyVideoLink}
                    onEnded={this.onEndVideo.bind(this)}
                    onProgress={this.onProgress.bind(this)}
                  /> 
                  {this.state.showSkipButton ? 
                    <div className="skip-button-align" onClick={this.onSkip.bind(this)}>Skip
                    <img src={skipIcon} style={{height:20,width:20,marginLeft:5,zIndex:9999}}/>
                    </div> 
                   : null}
                    </div>
                  }
                </div>

              </div>
              :
              leadOptionList
            }
            <ErrorDialogBox
              errorMsg = {this.state.errMsg}
              isErrorDialogVisible={this.state.isErrorDialogVisible}
              closeDialog={this.closeDialog.bind(this)}
            />
          </div>  
        </div>       
          <footer>
            <div className="col-sm-12 col-md-12 col-lg-12 no-Pd">
            {!this.state.isVideoPlay ?
                  <button
                    type="submit"
                    className="BuyBtnFooter primaryColor-ph2"
                    onClick={onSubmit}
                    > 
                    SUBMIT
                  </button>:
                 <button
                 type="submit"
                 className="BuyBtnFooter primaryColor-ph2"
                 style={{fontSize:12}}
                 > 
                 Watch small video to answer the survey and reduce maintenance
               </button>}
            </div>   
          </footer>
      </div>
 
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoading:state.survey.isLoading,
    detailOfSurvey:state.survey.detailOfSurvey,
    surveyList:state.survey.surveyList,
    leadQuestionList:state.survey.leadQuestionList,
    isShare :state.verify.isShare,
  };
};
const mapDispatchToProps = dispatch => {

  return bindActionCreators(
    {
      getDetailOfSurvey,
      selectSurveyOption,
      submitSurvey,
      selectLeadOption,
      storeSurveyData,
      handleChangeLeadQuestion
    },
    dispatch
  );
  
};

// #endregion
export default compose(
  connect(mapStateToProps, mapDispatchToProps),withRouter
)(Survey);
